/* eslint-disable */
/* istanbul ignore file */
import { useRef } from 'react';
import { isDate, isValid } from 'date-fns';
import StringMask from 'string-mask';
import DateFNS from 'date-fns';
import { getFrenquecyTypeById } from '../api/frequency-type';
import { FREQUENCY, FREQUENCY_DAYS } from '../config/frequency_type';
/**
 * Wrapper function to check if value is null, if so, return the default value provided.
 * @param {Any} value Value.
 * @param {Any} def Defualt value.
 */
export function _val(value, def = null) {
  return !(value === null || value === undefined) ? value : def;
}

/**
 * Helper function to create a date from UTC.
 */
export function fromUTC(date, zeroTime = false) {
  const d = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());

  if (zeroTime) {
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);
  } else {
    d.setHours(date.getUTCHours());
    d.setMinutes(date.getUTCMinutes());
    d.setSeconds(date.getUTCSeconds());
    d.setMilliseconds(date.getUTCMilliseconds());
  }
  return d;
}

/**
 * Helper function to create a date from UTC.
 */
export function fromISO(date, zeroTime = false) {
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  if (zeroTime) {
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);
  } else {
    d.setHours(date.getHours());
    d.setMinutes(date.getMinutes());
    d.setSeconds(date.getSeconds());
    d.setMilliseconds(date.getMilliseconds());
  }
  return d;
}

/**
 * Helper function to return an time without timezone.
 * @param {Date} date object to manipulate.
 */
export function utcTime(date = new Date()) {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0));
}

/**
 * Check if a given date is valid.
 * @param {Date} date object to be validated.
 */
export function isValidDate(date) {
  return isDate(date) && isValid(date);
}

/**
 * Helper function to sort arrays of strings.
 * @param {String} a String A.
 * @param {String} b String B.
 */
export function sortString(a, b) {
  if (!a && b) {
    return 1;
  } else if (!b && a) {
    return -1;
  } else if (!a && !b) {
    return 0;
  }

  let strA = a
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  let strB = b
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  if (strB > strA) {
    return -1;
  }
  if (strA > strB) {
    return 1;
  }
  return 0;
}

/**
 * Function to define a string in a pattern to be used in all search inputs.
 * @param {String} str term to search.
 */
export function toSearchableString(str) {
  return str ? str.trim().toLowerCase() : '';
}

/**
 * Helper function to sort arrays of numbers.
 * @param {Number} a Number A.
 * @param {Number} b Number B.
 */
export function sortNumber(a, b) {
  return a - b;
}

/**
 * sort array by key
 * @param {array} array.
 * @param {string} key.
 */
export const sortByKeyDesc = (array, key) =>
  array.sort(function (a, b) {
    const x = a[key];
    const y = b[key];
    return x > y ? -1 : x < y ? 1 : 0;
  });

/**
 * sort array by key
 * @param {array} array.
 * @param {string} key.
 */
export const sortByKeyAsc = (array, key) =>
  array.sort(function (a, b) {
    const x = a[key];
    const y = b[key];
    return x > y ? -1 : x > y ? 1 : 0;
  });

/**
 * Debounce implementation
 * @param {*} func
 * @param {*} wait
 */
export function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

export function useDebounce(func, wait) {
  const timeoutRef = useRef(null);
  return function (...args) {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      func(...args);
    }, wait);
  };
}

export function isEmpty(array) {
  return !array || array.length === 0;
}

export function isNil(value) {
  return value === null || value === undefined;
}

export function setValue(obj, path, value) {
  if (Object(obj) !== obj) return obj;
  if (!Array.isArray(path)) path = path.toString().match(/[^.[\]]+/g) || [];
  path
    .slice(0, -1)
    .reduce(
      (a, c, i) =>
        Object(a[c]) === a[c]
          ? a[c]
          : (a[c] = Math.abs(path[i + 1]) >> 0 === +path[i + 1] ? [] : {}),
      obj
    )[path.pop()] = value;
  return obj;
}

export function capitalize(str) {
  if (typeof str !== 'string') return '';
  return str.toLowerCase().replace(/(?:^|\s)\S/g, a => a.toUpperCase());
}

export function phoneMask(str) {
  let formatter = new StringMask('00(00) 0000-0000');
  let result = formatter.apply(str.substr(1, str.length));
  result = str.substr(0, 1) + result;
  return result;
}

export function toValueAndMeasure(valueInMinutes = 0) {
  const value = Number(valueInMinutes);
  const minutes = value;
  const hours = value / 60;
  const days = value / (24 * 60);
  const weeks = value / (7 * 24 * 60);
  const months = value / (30 * 24 * 60);

  if (minutes && minutes <= 59) {
    const value = minutes;
    const measure = value > 1 ? 'minutos' : 'minuto';

    return { value, measure };
  }

  if (months && months >= 1) {
    const value = months;
    const measure = value > 1 ? 'meses' : 'mês';

    return { value, measure };
  }

  if (weeks && weeks >= 1) {
    if (Number.isInteger(weeks)) {
      const value = weeks;
      const measure = value > 1 ? 'semanas' : 'semana';

      return { value, measure };
    } else {
      let months = 4;
      months /= weeks;

      const newMonth = Math.random(months);
      const value = newMonth;
      const measure = value > 1 ? 'meses' : 'mês';
      return { value, measure };
    }
  }

  if (days && days >= 1) {
    if (Number.isInteger(days)) {
      const value = days;
      const measure = value > 1 ? 'dias' : 'dia';

      return { value, measure };
    } else {
      let weeks = 7;
      weeks /= days;

      const newWeek = Math.random(weeks);
      const value = newWeek;
      const measure = value > 1 ? 'semanas' : 'semana';

      return { value, measure };
    }
  }

  if (hours && hours >= 1) {
    if (Number.isInteger(hours)) {
      const value = hours;
      const measure = value > 1 ? 'horas' : 'hora';

      return { value, measure };
    } else {
      let day = 24;
      day /= hours;

      const newDay = Math.round(day);
      const value = newDay;
      const measure = value > 1 ? 'dias' : 'dia';

      return { value, measure };
    }
  }

  if (hours && hours >= 1) {
    const value = minutes;
    const measure = value > 1 ? 'minutos' : 'minuto';

    return { value, measure };
  }

  return { value: -1, measure: 'Error' };
}

export function toValueAndMeasureFormatted(valueInMinutes = 0) {
  const value = Number(valueInMinutes);
  const minutes = value;
  const hours = value / 60;
  const days = value / (24 * 60);
  const weeks = value / (7 * 24 * 60);
  const months = value / (30 * 24 * 60);

  if (months && months >= 1) {
    let value = `${months}/${months}Mês`;
    return { value };
  }

  if (weeks && weeks >= 1) {
    let value;
    if (Number.isInteger(weeks)) {
      value = `${weeks}/${weeks} Sem`;
    } else {
      let months = 4;
      months /= weeks;

      const newMonth = Math.round(months);
      value = `${newMonth}xMês`;
    }
    return { value };
  }

  if (days && days >= 1) {
    let value;
    if (Number.isInteger(days)) {
      value = `${days}/${days}D`;
    } else {
      let weeks = 7;
      weeks /= days;

      const newWeeks = Math.round(weeks);
      value = `${newWeeks}xSem`;
    }
    return { value };
  }

  if (hours && hours >= 1) {
    let value;
    if (Number.isInteger(hours)) {
      value = `${hours}/${hours}h`;
    } else {
      let day = 24;
      day /= hours;

      const newDay = Math.round(day);
      value = `${newDay}xDia`;
    }
    return { value };
  }

  if (minutes && minutes >= 1) {
    const value = `${minutes}/${minutes}Min`;
    return { value };
  }

  return { value: -1, measure: 'Error' };
}

export function toMinutes(frequencyAmount, frequencyTypeId) {
  // frequencyAmount in minutes
  const MINUTES_IN_DAY = 1440;

  let minutes = null;

  if (frequencyTypeId === FREQUENCY.WEEK_ID) {
    minutes = frequencyAmount * FREQUENCY_DAYS.WEEK * MINUTES_IN_DAY;
  } else if (frequencyTypeId === FREQUENCY.BIWEEK_ID) {
    minutes = frequencyAmount * FREQUENCY_DAYS.BI_WEEK * MINUTES_IN_DAY;
  } else if (frequencyTypeId === FREQUENCY.MONTH_ID) {
    minutes = frequencyAmount * FREQUENCY_DAYS.MONTH * MINUTES_IN_DAY;
  } else if (frequencyTypeId === FREQUENCY.DAY_ID) {
    minutes = frequencyAmount * MINUTES_IN_DAY;
  } else if (frequencyTypeId === FREQUENCY.MINUTE_ID) {
    minutes = frequencyAmount;
  } else if (frequencyTypeId === FREQUENCY.HOUR_ID) {
    minutes = frequencyAmount * 60;
  }

  return minutes;
}

export function inMinutes(frequencyTypeId) {
  const MINUTES_IN_DAY = 1440;
  const MINUTES_IN_HOUR = 60;

  let minutes = null;

  if (frequencyTypeId === FREQUENCY.WEEK_ID) {
    minutes = FREQUENCY_DAYS.WEEK * MINUTES_IN_DAY;
  } else if (frequencyTypeId === FREQUENCY.BIWEEK_ID) {
    minutes = FREQUENCY_DAYS.BI_WEEK * MINUTES_IN_DAY;
  } else if (frequencyTypeId === FREQUENCY.MONTH_ID) {
    minutes = FREQUENCY_DAYS.MONTH * MINUTES_IN_DAY;
  } else if (frequencyTypeId === FREQUENCY.DAY_ID) {
    minutes = MINUTES_IN_DAY;
  } else if (frequencyTypeId === FREQUENCY.HOUR_ID) {
    minutes = MINUTES_IN_HOUR;
  } else if (frequencyTypeId === FREQUENCY.MINUTE_ID) {
    minutes = 1;
  }

  return minutes;
}

export function isObjEmpty(obj) {
  for (let prop in obj) {
    if (obj.hasOwnProperty(prop)) return false;
  }
  return true;
}

export function getVisitDuration(end, start) {
  const totalTimeInSeconds = DateFNS.differenceInSeconds(end, start);

  let days = Math.floor(totalTimeInSeconds / 86400);
  let hours = Math.floor((totalTimeInSeconds - days * 86400) / 3600);
  let minutes = Math.floor((totalTimeInSeconds - days * 86400 - hours * 3600) / 60);
  let seconds = totalTimeInSeconds - days * 86400 - hours * 3600 - minutes * 60;

  let timeString = '';
  if (days > 0) timeString = days + 'd ';
  if (hours > 0) timeString = timeString + hours + 'h ';
  if (minutes > 0) timeString = timeString + minutes + 'min ';
  if (seconds > 0) timeString = timeString + seconds + 's ';

  return timeString;
}

export function findIndexes(array, callback) {
  const indexes = [];

  array.forEach((element, index) => {
    if (callback(element, index) === true) indexes.push(index);
  });

  return indexes;
}

export function buildQueryString(params) {
  const query = new URLSearchParams();

  const arrEntries = Object.entries(params);

  // eslint-disable-next-line no-unused-vars
  for (const entry of arrEntries) {
    let [key, value] = entry;

    if (Array.isArray(value)) value = value.toString(); /* value = arrayToString(value) */

    value && query.append(key, value);
  }

  return query.toString();
}

// export function arrayToString(array) {
//   if (!Array.isArray(array)) throw Error();

//   if (array.length === 0) {
//     return '';
//   }
//   if (array.length === 1) {
//     return `${array[0]}`;
//   }
//   if (array.length > 1) {
//     return `${array.join(',')}`;
//   }
// }

export function codeGeneretor() {
  const randomNumber = () => Math.floor(Math.random() * 10);
  const number = `${randomNumber()}${randomNumber()}${randomNumber()}${randomNumber()}`;
  const randomCharacter = () => {
    const ref = 'ABCDEFGHIJKLMNOPQRSTUVXWYZ';
    return ref.charAt(Math.floor(Math.random() * ref.length));
  };
  const string = `${randomCharacter()}${randomCharacter()}${randomCharacter()}${randomCharacter()}`;

  const code = `${string}-${number}`;

  return code;
}

export function convertNumberToCurrency(value) {
  let stringValue = String(value.toFixed(2));
  if (value < 1) {
    stringValue = stringValue.replace('0.', '0,').replace('.', ',');
  } else {
    let integerPart = parseInt(value);
    let decimalPart = Math.abs(value - integerPart)
      .toFixed(2)
      .slice(2);
    stringValue = integerPart.toLocaleString();
    stringValue = stringValue.replace(',', '.') + ',' + decimalPart;
  }
  return stringValue;
}
/**
 * @description This function keep just properties defined
 * @param {object} obj objects with properties to be keeped
 * @param {String} properties that must be keeped
 * @returns {Array} object without the deleted property (s)
 */
export function keepObjectProperties(obj, properties) {
  for (const property in obj) {
    const shouldDeleteProperty = !properties.includes(property);

    if (shouldDeleteProperty) delete obj[property];
  }

  return obj;
}

/**
 * @description This function remove just properties defined
 * @param {object} obj objects with properties to be keeped
 * @param {String} properties that must be removed
 * @returns {Array} object without the deleted property (s)
 */
export function removeObjectProperties(obj, properties) {
  for (const property in obj) {
    const shouldDeleteProperty = properties.includes(property);

    if (shouldDeleteProperty) delete obj[property];
  }

  return obj;
}

/**
 * @description this function compares two objects and evaluates if the two are equal
 * @param {object} obj1 first object to compare
 * @param {object} obj2 second object to compare
 * @param {Array} exceptions arrays of keys to ignore in the comparison
 * @returns {Boolean}
 */
export const compareObjects = (obj1, obj2, exceptions = []) => {
  function bothNullOrUndefined(val1, val2) {
    return (val1 === null || val1 === undefined) && (val2 === null || val2 === undefined);
  }

  function bothEmptyArrays(val1, val2) {
    return Array.isArray(val1) && Array.isArray(val2) && val1.length === 0 && val2.length === 0;
  }

  function areDifferentButComparable(val1, val2) {
    return (
      (typeof val1 === 'string' && typeof val2 === 'number' && val1 === String(val2)) ||
      (typeof val1 === 'number' && typeof val2 === 'string' && String(val1) === val2)
    );
  }

  if (!obj1 || !obj2) {
    return false;
  }

  const obj1Keys = Object.keys(obj1);
  const obj2Keys = Object.keys(obj2);
  const allKeys = new Set([...obj1Keys, ...obj2Keys]);

  // eslint-disable-next-line no-unused-vars
  for (const key of allKeys) {
    if (exceptions.includes(key)) {
      continue;
    }

    if (!obj1Keys.includes(key) || !obj2Keys.includes(key)) {
      continue;
    }

    const val1 = obj1[key];
    const val2 = obj2[key];

    if (val1 === val2) {
      continue;
    }

    if (bothNullOrUndefined(val1, val2)) {
      continue;
    }

    if (bothEmptyArrays(val1, val2)) {
      continue;
    }

    if (areDifferentButComparable(val1, val2)) {
      continue;
    }

    return false;
  }

  return true;
};
